import { render, staticRenderFns } from "./CustomFieldTemplateMetadata.vue?vue&type=template&id=728995b0"
import script from "./CustomFieldTemplateMetadata.vue?vue&type=script&lang=js"
export * from "./CustomFieldTemplateMetadata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports